import React from 'react';
import PayrollPeriodFilter from 'domain/finance/payroll/List/filter/PayrollPeriodFilter';
import { FileList, Filters, ListHeader, ListPageLayout, LoadingListLayout, StaticFiltersLayout } from 'framework/list';
import usePayrollService from 'domain/finance/payroll/shared/payrollService';
import usePayrollDataChangesHandler from '../shared/payrollDataChangesHandler';
import OfficeFilter from './filter/OfficeFilter';
import { Grid2 as Grid } from '@mui/material';

const PayrollList = () => {
  const { getReport, getMaximalAvailablePeriod } = usePayrollService();

  const filters = (
    <Filters>
      <StaticFiltersLayout actionButtonName="Generate">
        <Grid container spacing={7}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <PayrollPeriodFilter source="period" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <OfficeFilter source="office" />
          </Grid>
        </Grid>
      </StaticFiltersLayout>
    </Filters>
  );

  const { modal, getDataMethod } = usePayrollDataChangesHandler(getReport);

  return (
    <>
      {modal}
      <FileList
        getDataMethod={getDataMethod}
        defaultFilters={{
          period: {
            eq: getMaximalAvailablePeriod(),
          },
          office: {
            eq: [],
          },
        }}
      >
        <ListPageLayout showTotal={false} header={<ListHeader label="Payroll" icon="fa-money" />} filter={filters} />
        <LoadingListLayout />
      </FileList>
    </>
  );
};

export default PayrollList;
